import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import sanitizeHtml from "sanitize-html";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { StyleTypeContext } from "../umbilical_tools";
import jssVariables from "../jss_setup";

const styles = createUseStyles({
  security: (props) => ({
    textAlign: "center",
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} * 2)`,
    padding: "0 5vw",
    paddingTop: `calc(9vh + ${jssVariables.normal_gap} * 2)`,
    paddingBottom: `calc(9vh + ${jssVariables.normal_gap} * 2)`,
    background: props.background,
    ..._.get(props, "customStyles.security", {}),
  }),
  header: (props) => ({
    color: props.titleTextColor,
    ..._.get(props, "customStyles.header", {}),
  }),
  description: (props) => ({
    fontSize: "large",
    color: props.textColor,
    height: "100%",
    ..._.get(props, "customStyles.description", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    security: (props) => ({
      padding: jssVariables.spacing.center_margin_large,
      paddingTop: `calc(9vh + ${jssVariables.normal_gap} * 4)`,
      paddingBottom: `calc(9vh + ${jssVariables.normal_gap} * 4)`,
      gridGap: `calc(${jssVariables.normal_gap} * 4)`,
      gridTemplateRows: "max-content max-content 1fr",
      ..._.get(props, "customStyles.security.smallscreen", {}),
    }),
  },
});

const Security = ({ baseColor, background, titleTextColor, textColor }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    baseColor,
    background,
    titleTextColor,
    textColor,
    customStyles: cStyler({
      type,
      brand,
      objName: "security",
    }),
  });

  const descriptive_sections = useSelector((state) =>
    _.get(
      state,
      "WebsiteMetadata.metadata.landing_page.descriptive_sections",
      []
    )
  );

  const security = descriptive_sections.find((d) => d.theme === "security");

  return (
    <React.Fragment>
      {security && (
        <div className={classes.security}>
          <h1 className={classes.header}>{security.name}</h1>
          <div
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(security.description),
            }}
          />
        </div>
      )}
    </React.Fragment>
  );
};

Security.defaultProps = {
  baseColor: "black",
  background: "white",
  textColor: "black",
  titleTextColor: "black",
};

Security.propTypes = {
  baseColor: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  titleTextColor: PropTypes.string.isRequired,
};

export default withRouter(Security);
